import { IconProps } from "./";
import Icon from "./assets/lock_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Lock(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
